import { createAction } from 'redux-actions';

import {
  CONNECT_TO_WEB_SOCKET,

  //staff practitioner
  LOAD_STAFF_PRACTITIONER_LIST,
  LOAD_STAFF_PRACTITIONER_LIST_SUCCESS,
  LOAD_STAFF_PRACTITIONER_LIST_ERROR,

  //booking slot
  LOAD_BOOKING_SLOT_LIST,
  SET_CURRENT_STEP,
  SET_PREVIOUS_STEP,
  SET_IS_FROM_EXTERNAL_SOURCE,
  LOAD_BOOKING_SLOT_LIST_SUCCESS,
  LOAD_BOOKING_SLOT_LIST_ERROR,

  //hold booking
  HOLD_BOOKING_SLOT,
  HOLD_BOOKING_SLOT_SUCCESS,
  HOLD_BOOKING_SLOT_ERROR,

  //set hold booking slot
  SET_HOLD_BOOKING_SLOT,

  //Release slot
  RELEASE_BOOKING_SLOT,
  RELEASE_BOOKING_SLOT_SUCCESS,
  RELEASE_BOOKING_SLOT_ERROR,

  //create Booking
  CREATE_BOOKING,
  CREATE_BOOKING_SUCCESS,
  CREATE_BOOKING_ERROR,
  LOAD_NEXT_AVAILABLE_BOOKING_SLOT_LIST,
  LOAD_NEXT_AVAILABLE_BOOKING_SLOT_LIST_SUCCESS,
  LOAD_NEXT_AVAILABLE_BOOKING_SLOT_LIST_LIST_ERROR,
} from './type';

export const connectToSocketAction = createAction(CONNECT_TO_WEB_SOCKET);

export const loadStaffPractitionerListAction = createAction(
  LOAD_STAFF_PRACTITIONER_LIST,
);
export const loadStaffPractitionerListSuccessAction = createAction(
  LOAD_STAFF_PRACTITIONER_LIST_SUCCESS,
);

export const loadStaffPractitionerListErrorAction = createAction(
  LOAD_STAFF_PRACTITIONER_LIST_ERROR,
);

//booking slot

export const loadBookingSlotListAction = createAction(LOAD_BOOKING_SLOT_LIST);

export const loadBookingSlotSuccessAction = createAction(
  LOAD_BOOKING_SLOT_LIST_SUCCESS,
);

export const loadBookingSlotErrorAction = createAction(
  LOAD_BOOKING_SLOT_LIST_ERROR,
);

// next available booking slot

export const loadNextAvailableBookingSlotListAction = createAction(
  LOAD_NEXT_AVAILABLE_BOOKING_SLOT_LIST,
);

export const loadNextAvailableBookingSlotSuccessAction = createAction(
  LOAD_NEXT_AVAILABLE_BOOKING_SLOT_LIST_SUCCESS,
);

export const loadNextAvailableBookingSlotErrorAction = createAction(
  LOAD_NEXT_AVAILABLE_BOOKING_SLOT_LIST_LIST_ERROR,
);

export const setCurrentStepAction = createAction(SET_CURRENT_STEP);
export const setPreviousStepAction = createAction(SET_PREVIOUS_STEP);
export const setIsFormExternalSource = createAction(
  SET_IS_FROM_EXTERNAL_SOURCE,
);
//   //hold booking action

export const holdBookingSlotAction = createAction(HOLD_BOOKING_SLOT);

export const holdBookingSlotSuccessAction = createAction(
  HOLD_BOOKING_SLOT_SUCCESS,
);

export const setHoldBookingSlotAction = createAction(SET_HOLD_BOOKING_SLOT);

export const holdBookingSlotErrorAction = createAction(HOLD_BOOKING_SLOT_ERROR);

export const releaseBookingSlotAction = createAction(RELEASE_BOOKING_SLOT);
export const releaseBookingSlotSuccessAction = createAction(
  RELEASE_BOOKING_SLOT_SUCCESS,
);
export const releaseBookingSlotErrorAction = createAction(
  RELEASE_BOOKING_SLOT_ERROR,
);

// create booking
export const createBookingAction = createAction(CREATE_BOOKING);
export const createBookingSuccessAction = createAction(CREATE_BOOKING_SUCCESS);
export const createBookingErrorAction = createAction(CREATE_BOOKING_ERROR);
